import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ColorTheme } from "./TypesAndConstants/const";

export interface ThemeProps {
  menuWidth?: string;
  containerWidth?: string;
  settingsBottom?: string;
}

const backgroundColor = ColorTheme.primary;

export const baseStyle = makeStyles<Theme, ThemeProps>((theme: Theme) => ({
  container: () => ({
    pointerEvents: "visible",
    margin: "auto",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  menu: (props) => ({
    elevation: 4,
    border: "1px solid",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    boxShadow: "2px 2px 20px #9a9797",
    width: props.containerWidth ? props.containerWidth : "50%",
    height: "7%",
    backgroundColor: backgroundColor,
    padding: "10px",
    position: "absolute",
    bottom: "0%",
    display: "inline-flex",
  }),
  mobileMenu: () => ({
    width: "100%",
  }),
  sideSettingMenu: (props) => ({
    background: "white",
    position: "absolute",
    left: "0",
  }),
  sideSettingMenuMobile: (props) => ({ background: "white", padding: "5px" }),
  sliderContainer: (props) => ({
    padding: "5px 10px",
  }),
  defaultFont: (props) => ({
    fontFamily: "'amatic', cursive !important",
  }),
  cards: () => ({
    zIndex: 300,
  }),
  shortcutButtonsBackground: ()=> ({
    fontFamily: "'amatic', cursive",
    fontSize: "1.1em",
    border: `2px solid ${ColorTheme.primaryText}`,
    borderRadius: "5px",
  }),
  shortcutMenuItem: ()=> ({
    verticalAlign: 'center',
    display: "inline-block",
    textAlign: "center",
    minWidth: "210px",
    padding: "4px",
    height: "100%",
    margin: "0px",
    cursor: "pointer",
    fontFamily: "'amatic', cursive",
    fontSize: "1.1em",
  }),
  background: () => ({
    fontFamily: "'amatic', cursive",
    fontSize: "1.1em",
    border: `2px solid ${ColorTheme.primaryText}`,
    borderRadius: "5px",
    boxShadow: "4px 4px 8px",
  }),
  modalBase: () => ({
    fontFamily: "'amatic', cursive",
    fontSize: "1.1em",
    border: `2px solid ${ColorTheme.primaryText}`,
    background: ColorTheme.primary,
    borderRadius: "5px",
    boxShadow: "4px 4px 8px",
  }),
  docked: () => ({
    cursor: "pointer",
    color: "#F4F4F4",
    fontFamily: "'amatic', cursive",
    background: "#555555",
    width: "20px",
    boxShadow:
      "inset 0 1px 1px #fff, inset 0 -1px 1px #aaa, 0 2px 4px -3px #666",
    "&:hover": { boxShadow: "inset 0 1px 1px #aaa, inset 0 -1px 1px #aaa" },
  }),
  dockedHorizontal: () => ({
    borderRadius: "20px",
    cursor: "pointer",
    color: "#F4F4F4",
    fontFamily: "'amatic', cursive",
    background: "#555555",
    height: "20px",
    padding: "2px",
    textAlign: "center",
  }),
  circleClose: () => ({
    borderRadius: "20px",
    cursor: "pointer",
    color: "white",
    background: "#555555",
    float: "right",
    width: "26px",
    textAlign: "center",
  }),
  buttonStyle: () => ({
    cursor: "pointer",
    color: "#F4F4F4",
    textAlign: "center",
    background: "#555555",
    height: "25px",
    boxShadow:
      "inset 0 1px 1px #fff, inset 0 -1px 1px #aaa, 0 2px 4px -3px #666",
    "&:hover": { boxShadow: "inset 0 1px 1px #aaa, inset 0 -1px 1px #aaa" },
  }),
}));
